/** @module csi/dgrid/MatrixEditorWithCheckBox */
define([
	"dojo/_base/declare",
	"csi/dgrid/MatrixEditor",
	"csi/widget/CheckBox"
], function(declare,MatrixEditor,CheckBox) {

	return declare(MatrixEditor, {
		'class': 'csi-matrix-editor-checkbox',
		defaultValue: false,
		editorArgs: null,
		editorClass: CheckBox
	});
});
